import { MockPaymentAccount } from 'modules/account/account/MockPaymentAccount';
import { ConfigurationFeatures } from './detail/configurations/ConfigurationFeatures';
const MASTER_TEMPLATE = 'master';
export class ApplicationService2 {
    static $inject = ['ApplicationTeamService', 'AuthenticationService', 'BlipService', 'MediaService', 'FileService', 'HostingService', 'MessagingHubService', 'BLIP_DOMAIN', 'MESSAGINGHUBDOMAIN', '$http', '$rootScope', 'InitializeUserService', '$base64'];
    constructor(ApplicationTeamService, AuthenticationService, BlipService, MediaService, FileService, HostingService, MessagingHubService, BLIP_DOMAIN, MESSAGINGHUBDOMAIN, $http, $rootScope, InitializeUserService, $base64) {
        'ngInject';
        this.ApplicationTeamService = ApplicationTeamService;
        this.AuthenticationService = AuthenticationService;
        this.BlipService = BlipService;
        this.MediaService = MediaService;
        this.FileService = FileService;
        this.HostingService = HostingService;
        this.MessagingHubService = MessagingHubService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.InitializeUserService = InitializeUserService;
        this.$base64 = $base64;
        this.getAuthHeaderValue = (application) => {
            const originalKey = this.$base64.decode(application.accessKey);
            const userAndKey = `${application.shortName}:${originalKey}`;
            return `Key ${this.$base64.encode(userAndKey)}`;
        };
        this.MockPaymentAccount = new MockPaymentAccount();
        this.$onInit();
    }
    async $onInit() {
        await this.checkFeatures();
    }
    async checkFeatures() {
        if (!this.$rootScope.featureToggleInitialized) {
            await this.InitializeUserService.initFeatureToggle();
        }
        this.isSanitizeAccessKeyInBot = await ConfigurationFeatures.isSanitizeAccessKeyInBot();
    }
    /**
     * Stores the application account information.
     * @param account
     */
    async setAccount(account) {
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.account+json',
            uri: '/account',
            resource: account,
        });
    }
    /**
     * Gets the application account.
     */
    async getAccount() {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/account',
        });
    }
    /**
     * Deletes the application account.
     */
    async deleteAccount() {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            uri: '/account',
        });
    }
    /**
     * Gets all access keys associated with the application account.
     */
    async getAccessKeys() {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/account/keys',
        });
    }
    /**
     * Deletes an application access key by its id.
     * @param accessKeyId
     */
    async deleteAccessKey(accessKeyId) {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            uri: `/account/keys/${accessKeyId}`,
        });
    }
    /**
     * set key associated with the server.
     */
    async setAccessKeys(purpose) {
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            uri: '/account/keys',
            type: 'application/vnd.iris.keyRequest+json',
            resource: {
                'purpose': purpose,
            },
        });
    }
    /**
     * Closes any active session of the application.
     */
    async closeSessions() {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            uri: '/sessions',
        });
    }
    /**
     * Check if an application is online.
     * @param application
     */
    async isOnline(application) {
        const response = await this.MessagingHubService.processCommand({
            to: `${application.shortName}@${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: '/ping',
        });
        if (response.status === 'failure') {
            return false;
        }
        return true;
    }
    async getUsers(application) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `/account/${application.shortName}/users`,
        });
    }
    async getUsersAccounts(application, skip = 0, take = 500, orderByUserIdentity = false, fetchAll = false) {
        await this.connectBlipClient();
        let uri = orderByUserIdentity
            ? `/applications/${application.shortName}@${this.MESSAGINGHUBDOMAIN}/users/accounts?orderByUserIdentity=${orderByUserIdentity}`
            : `/applications/${application.shortName}@${this.MESSAGINGHUBDOMAIN}/users/accounts?$skip=${skip}&$take=${take}&orderByUserIdentity=${orderByUserIdentity}`;
        if (fetchAll) {
            uri += `&fetchAll=${fetchAll}`;
        }
        const response = await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: uri,
        });
        return response.items.map(item => ({ user: item }));
    }
    async getApplicationUsersPermissions(application, skip = 0, take = 9999) {
        await this.connectBlipClient();
        const response = await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/applications/${application.shortName}@${this.MESSAGINGHUBDOMAIN}/permissions?$skip=${skip}&$take=${take}`,
        });
        return response.items;
    }
    async connectBlipClient() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
    getLocalNode() {
        return this.BlipService.localNode;
    }
    async getApplications(tenantId) {
        await this.connectBlipClient();
        const uri = tenantId
            ? `/applications?tenantId=${tenantId}`
            : '/applications';
        const response = await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri,
        });
        return response.items.filter(app => app.template != 'pipeline').map(item => ({ ...item, id: item.shortName, showApplication: true })).reverse();
    }
    async getHistoricApplications(tenantId, groupId, userIdentify) {
        try {
            let uri = `/queue-migration/tenants/${tenantId}/history`;
            if (groupId) {
                uri = uri + `?groupId=${groupId}`;
            }
            if (userIdentify) {
                uri = uri + '?userIdentity=' + encodeURIComponent(`${userIdentify}` + `@${this.BLIP_DOMAIN}`);
            }
            const response = await this.BlipService.processCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri,
            });
            return response.resource?.items.map(item => ({ ...item, UserIdentity: item.User }));
        }
        catch (e) {
            console.log(e);
            return undefined;
        }
    }
    async getApplication(shortName) {
        await this.connectBlipClient();
        const application = await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/applications/${shortName}@${this.MESSAGINGHUBDOMAIN}`,
        });
        application.applicationUserPermissionModel = await this.ApplicationTeamService.getUserApplicationPermissionModel(shortName);
        return application;
    }
    async getApplicationJSON(shortName) {
        const application = await this.getApplication(shortName);
        await this.MessagingHubService.resetClient(application);
        let applicationJson = undefined;
        if (!application.template ||
            application.template === 'sdk' ||
            application.template === 'undefined' ||
            application.template === 'webhook') {
            applicationJson = application;
            application.isTemplate = false;
        }
        else {
            applicationJson = await this.HostingService.getApplicationJson(application);
            application.isTemplate = true;
        }
        if (await ConfigurationFeatures.isSanitizeAccessKeyInBot()) {
            delete applicationJson.accessKey;
        }
        application.applicationJson = applicationJson;
        return application;
    }
    async getApplicationsByTenant(tenantId) {
        await this.connectBlipClient();
        const response = await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/tenants/${tenantId}/applications`,
        });
        return response.items.filter(app => app.template != 'pipeline').map(item => ({ ...item, id: item.shortName, showApplication: true }));
    }
    async getWhatsAppApplicationsByTenant(tenantId) {
        await this.connectBlipClient();
        const { resource } = await this.BlipService.processCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/tenants/${tenantId}/whatsapp-applications`,
        });
        return resource.items.map(item => ({ ...item, id: item.identity }));
    }
    async getCallingPhoneNumberSettings(ownerIdentity) {
        await this.connectBlipClient();
        const { resource } = await this.BlipService.processCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/applications/${ownerIdentity}/phone-number-settings-calling`,
        });
        return resource;
    }
    async setApplicationPhoneNumberSettings({ tenantId, applicationIdentity, settings, }) {
        await this.connectBlipClient();
        const response = await this.BlipService.processCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'set',
            uri: `lime://${applicationIdentity}/tenants/${tenantId}/whatsapp-applications`,
            type: 'application/vnd.iris.whatsapp.phone-number-settings+json',
            resource: settings,
        });
        return response;
    }
    async getCallsTerms(tenantId) {
        await this.connectBlipClient();
        const response = await this.BlipService.processCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/tenants/${tenantId}/calls-terms`,
        });
        return response;
    }
    async getAdminApplications(tenantId) {
        const queryParams = tenantId ? `?tenantId=${tenantId}` : '';
        const response = await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/applications-admin${queryParams}`,
        });
        return response.items.map(i => i.replace(`@${this.MESSAGINGHUBDOMAIN}`, ''));
    }
    queryAdminByTenant(filter) {
        return this.getApplicationsByTenant(filter.tenantId);
    }
    async getApplicationPaymentAccount(shortName) {
        return this.MockPaymentAccount.get(shortName);
    }
    async isUserOnlyAdmin(shortName) {
        await this.connectBlipClient();
        const encodedShortName = `${shortName}@${this.MESSAGINGHUBDOMAIN}`;
        const response = await this.BlipService.processCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/applications/${encodedShortName}/islastadmin`,
            metadata: {
                'server.shouldStore': true,
            },
        });
        return response.resource;
    }
    async setApplication(application, tenantId) {
        await this.connectBlipClient();
        const uri = application.messagingHubCommandWithDelegation ?
            `/applications?messagingHubCommandWithDelegation=${application.messagingHubCommandWithDelegation}` :
            '/applications';
        return await this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'set',
            type: 'application/vnd.iris.portal.application-account+json',
            uri: uri,
            resource: {
                description: application.description,
                imageUri: application.imageUri,
                name: application.name,
                shortName: application.shortName,
                template: application.template,
                tenantId: tenantId,
                layout: application.layout,
            },
        });
    }
    async setApplicationAccessKey(shortName, accessKey) {
        await this.connectBlipClient();
        return this.BlipService.sendCommand({
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'set',
            type: 'application/vnd.iris.portal.application-access-key+json',
            uri: `/applications/${shortName}@${this.MESSAGINGHUBDOMAIN}/access-key`,
            resource: {
                'accessKey': accessKey,
            },
        });
    }
    async setUpApplication(application, tenantId) {
        const account = await this.getAccount();
        const applicationAccount = {
            ...account,
            extras: {
                ...account.extras,
                template: application.template,
                tenantId,
            },
        };
        await this.connectBlipClient();
        await this.BlipService.sendCommand({
            from: application.identifier,
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'set',
            type: 'application/vnd.lime.account+json',
            uri: '/applications',
            resource: {
                ...applicationAccount,
            },
        });
    }
    async deleteApplication(application) {
        const account = await this.getAccount();
        const uri = application.messagingHubCommandWithDelegation ?
            `/applications/${account.identity}?messagingHubCommandWithDelegation=${application.messagingHubCommandWithDelegation}` :
            `/applications/${account.identity}`;
        await this.connectBlipClient();
        await this.BlipService.sendCommand({
            from: application.identifier,
            to: `postmaster@portal.${this.BLIP_DOMAIN}`,
            method: 'delete',
            uri: uri,
        });
    }
    async deleteAndRevokeApplication(application) {
        // Close sessions
        try {
            await this.closeSessions();
        }
        catch (err) {
            //Cód. 67: No session found for current owner identity
            if (err.code != 67) {
                console.error(err);
            }
        }
        // Delete all access keys
        const accessKeys = await this.getAccessKeys();
        for (let i = 0; i < accessKeys.items.length; i++) {
            const accessKey = accessKeys.items[i];
            await this.deleteAccessKey(accessKey.id);
        }
        // Disconnect the application
        if (application.isTemplate) {
            try {
                await this.HostingService.unpublish(application);
            }
            catch (err) {
                console.error(err);
            }
        }
        // Delete application
        await this.deleteApplication(application);
        this.MessagingHubService.closeClient(application);
    }
    async uploadFile(file, options) {
        const { secure = false, type, profile } = options || {};
        const mediaIsDataURI = this.FileService.isDataURI(file);
        if (!file || (typeof file === 'string' && !mediaIsDataURI)) {
            return file;
        }
        await this.connectBlipClient();
        const { resource } = await this.MediaService.getMediaUploadUri(secure, profile);
        const fileUpload = mediaIsDataURI
            ? this.FileService.fromDataURI(file)
            : file;
        try {
            const { data } = await this.$http.post(resource, fileUpload, {
                headers: {
                    'Content-Type': type || fileUpload.type,
                },
            });
            return data.mediaUri;
        }
        catch (e) {
            throw e;
        }
    }
    async uploadBlob(blob, secure = false, type, profile) {
        try {
            await this.connectBlipClient();
            const { resource } = await this.MediaService.getMediaUploadUri(secure, profile);
            const { data } = await this.$http.post(resource, blob, {
                headers: {
                    'Content-Type': type,
                },
            });
            return data.mediaUri;
        }
        catch (e) {
            throw e;
        }
    }
    getChannel(channelName, application) {
        return application?.channels?.find(c => c.name === channelName);
    }
    getChannelIndex(channel, application) {
        return application?.channels?.findIndex(c => c.name === channel.name);
    }
    computeChannel(channel, application) {
        const channelIndex = this.getChannelIndex(channel, application);
        if (channelIndex === -1) {
            application.channels.push(channel);
        }
        else {
            application.channels[channelIndex] = channel;
        }
    }
    removeChannel(channel, application) {
        const channelIndex = this.getChannelIndex(channel, application);
        application.channels.splice(channelIndex, 1);
    }
    computeOrRemoveChannel(channel, application) {
        if (channel.configurations.IsChannelActive === 'True') {
            this.computeChannel(channel, application);
        }
        else {
            this.removeChannel(channel, application);
        }
    }
    isThisMasterApplication(application) {
        return application.template === MASTER_TEMPLATE;
    }
    async getApplicationsWithChildren(shortName, tenantId) {
        try {
            const uri = tenantId
                ? `/application-with-children/${shortName}@${this.MESSAGINGHUBDOMAIN}?tenantId=${tenantId}`
                : `/application-with-children/${shortName}@${this.MESSAGINGHUBDOMAIN}`;
            const response = await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri,
            });
            return response.items.map(item => ({ ...item, id: item.shortName, disabled: true }));
        }
        catch (e) {
            const error = JSON.parse(e);
            if (error.reason.code !== 67) {
                console.error(e);
            }
            return undefined;
        }
    }
}
ApplicationService2.$inject = ['ApplicationTeamService', 'AuthenticationService', 'BlipService', 'MediaService', 'FileService', 'HostingService', 'MessagingHubService', 'BLIP_DOMAIN', 'MESSAGINGHUBDOMAIN', '$http', '$rootScope', 'InitializeUserService', '$base64'];
